module.exports = __webpack_public_path__ + "img/logo_reliance_biru.d4cce95d.png";